export default "__VITE_ASSET__qJljjWGP__"